<template>
<el-button 
    class="hydroware-view-button"
    size="small" 
    title="View"
    value="view"
    v-bind="$attrs"
    v-on="$listeners"
    style=width:30px;height:30px;>
    <i class="fa fa-eye fa-lg" style=position:relative;left:-3px;top:-1px></i>
    <span v-if="text">{{text}}</span>
</el-button>
</template>
<script>
export default {
    data() {
        return {
            buttonType: "view"
        }
    },
    props: ['text','buttonType']
  }
</script> 


// WEBPACK FOOTER //
// hydroware-view-button.vue?4bd17b42